/** @jsx jsx */
/* eslint-disable no-use-before-define,no-empty-pattern */
import { jsx } from '@emotion/core'
import React from 'react'
import { fmt, YES_NO, COUPON_FREQUENCY_LABELS, openWindow, parseHtml, parseDate, Flyout, } from '../twd'
import { useBondDetail } from './use-bond-detail'
import { INV_TYPE_LABELS } from './bond-detail'
import { listCss } from './style'
import CouponType from './coupon-type'
import { Sell, Buy, Bid, Ask, BidWanted, OfferWanted } from './order'

export default ({}) => {
    const {issue, offer, bid, ask, hold, } = useBondDetail()

    let invType = issue.type
    let isMBS = ['O', 'R', 'K'].indexOf(invType)>=0

    return <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-9">
            <h2 className='large-header'>{issue.issueDisplay}</h2>
            <h6 className='subhead' dangerouslySetInnerHTML={{__html:parseHtml(issue.descriptionInfo).replace('<br>','')}} />
        </div>
        <div className="col-xs-12 col-md-3 text-right">
            <AddToWatclisthButton />
            <Sell />
            <Buy />
        </div>
        </div>

        <div className="row">
        <dl css={listCss}>
            <div className="col-md-4 col-xs-12">
            <dt>Bid</dt>
            <dd><Bid dataName='bond-detail-header-bid' /></dd>
            <dt>Bid qty</dt>
            <dd>{fmt.qty(bid.quantity)}</dd>
            <dt>Bid YTM/YTW</dt>
            <dd>{fmt.ytw3(bid.ytm)} / {fmt.ytw3(bid.ytw)}</dd>
            <dt>Ask</dt>
            <dd><Ask dataName='bond-detail-header-ask' /></dd>
            <dt>Ask qty</dt>
            <dd>{fmt.qty(ask.quantity)}</dd>
            <dt>Ask YTM/YTW</dt>
            <dd>{fmt.ytw3(ask.ytm)} / {fmt.ytw3(ask.ytw)}</dd>
            <dt>Quote request</dt>
            <dd style={{fontWeight:'normal'}}>
                {(() => {
                    let isMatured = parseDate(issue.maturityEff) < Date.now()
                        || parseDate(issue.redemptionDt) < Date.now()
                        || issue.calledInFullInd === 'Y'
                    let arr = [
                        !isMatured && issue.allowTrading && hold.length>0 ? <BidWanted dataName='bond-detail-header-bid-wanted' /> : null,
                        !isMatured && issue.allowTrading && issue.newIssueInd!=='Y' && issue.type!=='P' ? <OfferWanted dataName='bond-detail-header-bid-wanted' /> : null,
                    ].filter(Boolean)

                    return arr.length===0 ? fmt.empty()
                        : arr.length===1 ? arr[0]
                        : <React.Fragment>{arr[0]} | {arr[1]}</React.Fragment>
                })()}
            </dd>
            </div>

            <div className="col-md-4 col-xs-12">
            <dt>Product Type</dt>
            <dd>{(() => {
                let invType = issue.spInd==='Y' ? 'L' : issue.type
                return INV_TYPE_LABELS[invType] || fmt.empty()
            })()}</dd>
            <dt>CUSIP</dt>
            <dd>{issue.cusip}</dd>
            <dt>ISIN</dt>
            <dd>{issue.isin}</dd>
            <dt>Maturity date</dt>
            <dd>{fmt.mdy(issue.maturity)}</dd>
            <dt>Callable</dt>
            <dd>{YES_NO[isMBS ? 'N' : issue.callableInd] || fmt.empty()}</dd>
            <dt>New issue</dt>
            <dd>{YES_NO[issue.newIssueInd] || fmt.empty()}</dd>
            </div>

            <div className="col-md-4 col-xs-12">
            <dt>Coupon</dt>
            <dd>{fmt.ytw3(issue.coupon)}</dd>
            <dt>Coupon type</dt>
            <dd><CouponType issue={issue} offer={offer} /></dd>
            <dt>Next coupon</dt>
            <dd>{fmt.mdy(issue.nextCoupon)}</dd>
            <dt>Last coupon</dt>
            <dd>{fmt.mdy(issue.lastCoupon)}</dd>
            <dt>Pay frequency</dt>
            <dd>{COUPON_FREQUENCY_LABELS[issue.frequencyCode] || fmt.empty()}</dd>
            <dt>Min denom/increment</dt>
            <dd>{fmt.qty(issue.minAmt)}x{fmt.qty(issue.denominationAmt)}</dd>
            </div>


        </dl>
        </div>
        <div className="row vertical-offset-sm"></div>

    </React.Fragment>
}


let AddToWatclisthButton = () => {

    return <Flyout
        html={"Add to watchlist"}
        className="link-button large-header"
        placement='bottom'
        trigger={["hover", "focus"]}
        iconName='playlist_add'
        iconCls="material-icons et-icon-xs"
        popperStyles={{width:'150px'}}
        isButton={false}
        onClick={() => {
            openWindow('https://us.etrade.com/etx/pw/watchlists#/wl')
        }}
    />
}


// WEBPACK FOOTER //
// ./src/bond-detail/header.js